import React from "react";
import "../styles/Vote.css";

const Vote = () => {
  const voteLinks = [
    { name: "TopG", url: "https://topg.org/minecraft-servers/server-667435" },
    { name: "Minecraft Buzz", url: "https://minecraft.buzz/vote/12095" },
    { name: "CraftList", url: "https://craftlist.org/rixxymc?nickname=Steve" },
    { name: "Minecraft MP", url: "https://minecraft-mp.com/server/338489/vote/" },
    { name: "Top Minecraft Servers", url: "https://topminecraftservers.org/vote/39041" },
    { name: "Minecraft Server Net", url: "https://minecraft-server.net/vote/RixxyMC/" },
    { name: "MC Server List", url: "https://mc-server-list.com/server/2135-rixxymc/vote/" },
  ];

  const rewards = ["₹500 Coins", "1x Vote Key", "50 Claim Blocks", "Voter Rank (24h)"];

  return (
    <div className="vote-page">
      <div className="vote-hero">
        <h1>🗳️ <span>Vote for</span> <span className="rixxy-highlight">RixxyMC</span></h1>
        <p>Support the server and claim exclusive daily rewards!</p>
      </div>

      <div className="rewards-box">
        <h2>🎁 What You Get</h2>
        <div className="reward-list">
          {rewards.map((item, index) => (
            <div className="reward" key={index}>
              ✅ {item}
            </div>
          ))}
        </div>
        <p className="rewards-note">✨ Rewards for <strong>every vote</strong> on all platforms!</p>
      </div>

      <div className="vote-links-section">
        <h2>🌐 Vote On These Sites</h2>
        <p>Click below to vote on each platform:</p>
        <div className="vote-grid">
          {voteLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="vote-card"
            >
              <div className="vote-card-content">
                <h3>⭐ {link.name}</h3>
                <button className="vote-btn">Vote Now</button>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Vote;
